import { HttpClient } from '@angular/common/http';
import { ReturnStatement } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Token } from '../models/token.model';
import { GenelService } from '../services/genel.service';

@Injectable({
  providedIn: 'root'
})
export class GirisGuard implements CanActivate {

  constructor(private http: HttpClient, private genelService : GenelService){};

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.genelService.GirisKontrol();

  }
  
}
